module.exports = __webpack_public_path__ + "img/under-maintenance-dark.c6035f56.svg";